import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.accountSettings || initialState;

export const selectAccountSettings = createSelector(
  [selectSlice],
  state => state,
);

export const selectChangePassword = createSelector(
  [selectSlice],
  state => state.changePassword,
);
